import { AnyAction } from 'redux';

import { SelectorLocation } from '@candu-ai/placement/types';
import { ToolboxTabs } from 'craft/types';

import {
  SET_COMPONENTS_SEARCH,
  SET_FORCE_PLACEMENTS_TAB,
  SET_PALETTE_APPEARANCE,
  SET_PALETTE_LAYERS_HIDDEN,
  SET_PALETTE_TAB,
  SET_PLACEMENT_MODE,
  SET_PREVIEW_SELECTOR,
  SET_PREVIEW_SELECTOR_LOCATION,
  SET_TOOLBOX_TAB,
} from './constants';

export enum PaletteAppearance {
  COLLAPSED = 'COLLAPSED',
  PINNED = 'PINNED',
}

export interface MenuState {
  toolboxTab: ToolboxTabs;
  paletteTab: null;
  paletteAppearance: PaletteAppearance;
  hiddenLayers: boolean;
  componentsSearch?: string;
  forcePlacementsTab: boolean;
  placementMode: boolean;
  previewSelector?: string;
  previewSelectorLocation?: SelectorLocation;
}

const PALETTE_APPEARENCE_KEY = 'candu.paletteAppearence';
const getPaletteAppearence = () => {
  const localstorageAppearence = window.localStorage.getItem(PALETTE_APPEARENCE_KEY);
  if (!localstorageAppearence && window.screen.width > 1000) {
    return PaletteAppearance.PINNED;
  }
  return localstorageAppearence === PaletteAppearance.PINNED
    ? PaletteAppearance.PINNED
    : PaletteAppearance.COLLAPSED;
};

export const initialState: MenuState = {
  toolboxTab: ToolboxTabs.Component,
  paletteTab: null,
  paletteAppearance: getPaletteAppearence(),
  hiddenLayers: false,
  forcePlacementsTab: false,
  placementMode: false,
};

export const menuReducer = (state: MenuState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_COMPONENTS_SEARCH:
      return { ...state, componentsSearch: action.componentsSearch };

    case SET_PALETTE_APPEARANCE:
      window.localStorage.setItem(PALETTE_APPEARENCE_KEY, action.paletteAppearance);
      return {
        ...state,
        paletteAppearance: action.paletteAppearance,
      };

    case SET_PALETTE_LAYERS_HIDDEN:
      return {
        ...state,
        hiddenLayers: action.hiddenLayers,
      };

    case SET_PALETTE_TAB:
      return {
        ...state,
        ...(!action.paletteTab ? { componentsSearch: null } : {}),
        paletteTab: action.paletteTab,
      };

    case SET_TOOLBOX_TAB:
      return { ...state, toolboxTab: action.toolboxTab };

    case SET_PLACEMENT_MODE:
      return { ...state, placementMode: action.placementMode };

    case SET_PREVIEW_SELECTOR:
      return { ...state, previewSelector: action.previewSelector };

    case SET_PREVIEW_SELECTOR_LOCATION:
      return { ...state, previewSelectorLocation: action.previewSelectorLocation };

    case SET_FORCE_PLACEMENTS_TAB:
      return {
        ...state,
        // if we force the palette tab, close the palette
        paletteTab: null,
        forcePlacementsTab: action.forcePlacementsTab,
      };

    default:
      return state;
  }
};
